import { render } from "./AgendaCard.vue?vue&type=template&id=08032326&scoped=true"
import script from "./AgendaCard.vue?vue&type=script&lang=js"
export * from "./AgendaCard.vue?vue&type=script&lang=js"

import "./AgendaCard.vue?vue&type=style&index=0&id=08032326&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08032326"]])

export default __exports__